var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgStackedBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 86,
    viewBox: "0 0 185 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 15,
    transform: "matrix(-1 0 0 1 51.5853 70)",
    fill: "#DA1E28",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 75,
    transform: "matrix(-1 0 0 1 23.317 10)",
    fill: "#0E6027",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.317,
    y: 10,
    width: 22.3171,
    height: 9,
    transform: "rotate(-180 23.317 10)",
    fill: "#F44D56",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 57,
    transform: "matrix(-1 0 0 1 23.317 28)",
    fill: "#42BE65",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 42,
    transform: "matrix(-1 0 0 1 23.317 43)",
    fill: "#78A9FF",
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 10.1786,
    transform: "matrix(-1 0 0 1 117.793 74.8215)",
    fill: "#DA1E28",
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 50.8929,
    transform: "matrix(-1 0 0 1 89.5243 34.1071)",
    fill: "#0E6027",
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5243,
    y: 34.1071,
    width: 22.3171,
    height: 6.10714,
    transform: "rotate(-180 89.5243 34.1071)",
    fill: "#F44D56",
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 38.6786,
    transform: "matrix(-1 0 0 1 89.5243 46.3215)",
    fill: "#42BE65",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 28.5,
    transform: "matrix(-1 0 0 1 89.5243 56.5)",
    fill: "#78A9FF",
    stroke: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 10.1786,
    transform: "matrix(-1 0 0 1 184 74.8215)",
    fill: "#DA1E28",
    stroke: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 68,
    transform: "matrix(-1 0 0 1 155.732 17)",
    fill: "#0E6027",
    stroke: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 155.732,
    y: 17,
    width: 22.3171,
    height: 8,
    transform: "rotate(-180 155.732 17)",
    fill: "#F44D56",
    stroke: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 38.6786,
    transform: "matrix(-1 0 0 1 155.732 46.3215)",
    fill: "#42BE65",
    stroke: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3171,
    height: 28.5,
    transform: "matrix(-1 0 0 1 155.732 56.5)",
    fill: "#78A9FF",
    stroke: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgStackedBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stacked-bar-chart.75d49831986904ad5b7628230ea42277.svg";